import { siteInfo } from '@/mocks/feed';
import SubscribeForm from '@/components/feature/SubscribeForm';
import SectionHeading from '@/components/base/SectionHeading';

export default function AboutContact() {
  return (
    <section id="contact" className="mt-16 border-t border-background-200/70 pt-14">
      <SectionHeading
        eyebrow="Contact"
        title="联系方式：写信比喊话更好用"
        desc="如果你发现某条整理有误，或者手里有可公开验证的材料，直接写信说明即可，我们会重新核对并更新条目。"
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                <i className="ri-mail-line text-xl" />
              </span>
              <div>
                <p className="font-label text-xs tracking-widest text-foreground-500">主要联系邮箱</p>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="font-heading text-base font-bold text-foreground-950 transition-colors hover:text-primary-300"
                >
                  {siteInfo.email}
                </a>
              </div>
            </div>

            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-start gap-3 text-foreground-700">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                值夜时段内（00:00 - 07:00）的来信，通常会在当天白天统一回复。
              </li>
              <li className="flex items-start gap-3 text-foreground-700">
                <i className="ri-file-shield-2-line mt-0.5 text-accent-400" />
                涉及更正的内容，请附上可公开验证的链接或截图来源说明。
              </li>
              <li className="flex items-start gap-3 text-foreground-700">
                <i className="ri-forbid-line mt-0.5 text-accent-400" />
                不接受无法核实来源的单方面描述，也不代为发布指向任何个人的内容。
              </li>
            </ul>

            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-6 inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 font-label text-sm text-white transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" />
              写邮件给我们
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}